import styled from "styled-components";
import Profile from "../../common/Profile";
import { statusData } from "../data";

const StatusBoxWrapper = styled.div`
  display: flex;
  > div:first-child {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 16px;
  }
  > div:last-child {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    padding-bottom: 32px;
  }
`;
const Line = styled.div`
  width: 1px;
  height: 100%;
  background-color: #e6e6ea;
`;
const StatusButton = styled.span`
  display: inline-block;
  padding: 6px 24px;
  background-color: ${(props) => props.bgColor};
  border-radius: 30px;
  font-weight: bold;
  margin: 0px 16px;
  &:hover {
    cursor: default;
  }
`;
const RowBar = styled.div`
  width: 100%;
  height: 1px;
  background-color: black;
`;

const StatusBox = ({ isLastMsg, msg }) => {
  const getDisplayExprFromDataSource = (value) => {
    const data = statusData.find((el) => el.value === value);
    return <StatusButton bgColor={data.hex}>{data.text}</StatusButton>;
  };

  return (
    <>
      <StatusBoxWrapper>
        <div>
          <Profile employeeNo={msg.au} />
          {!isLastMsg ? <Line /> : ""}
        </div>
        <div>
          <span style={{ fontWeight: "bold", marginRight: "5px" }}>{msg.auName}</span> changed status to{" "}
          {getDisplayExprFromDataSource(msg.descr)} on {msg.date}
        </div>
      </StatusBoxWrapper>
      {isLastMsg ? <RowBar /> : ""}
    </>
  );
};

export default StatusBox;
